export interface NavItem {
  readonly hideDesktop: boolean;
}

export const filterDesktop = <T extends NavItem>(items: ReadonlyArray<T>): Array<T> =>
  items.filter((item) => !item.hideDesktop);
